import React, { Component } from "react";
import MapContainer from "../../components/Dashboard/Dashboard_map";
import myConfig from "../../configs/config";
import axios from "axios";
import { getErrorComponent, getFormatedDate, buildUtcFromToParams } from "../../helpers/utils";
import { withTranslation } from "react-i18next";
import PoupUp from "../../components/PoupUp";
import KpisGadgets from "./KpiGadgets";
import { Link } from "react-router-dom";
import { FaCompress, FaExpand, FaMapMarkedAlt, FaPlus } from "react-icons/fa";
import { FloatingWhatsApp } from "@carlos8a/react-whatsapp-floating-button";
import RadioMapWidget from "../Radio/RadioMapWidget";
import DashboardHourlyForecastBar from "../../components/Dashboard/DashboardHourlyForecastBar";
import DashboardDailyForecastColumn from "../../components/Dashboard/DashboardDailyForecastColumn";
import DashboardWindArrow from "../../components/Dashboard/DashboardWindArrow";
import DashboardTracePanel from "./DashboardTracePanel";
import "../../components/Dashboard/DraggableMapControl.css";
import {
  appendMovedPoint,
  buildOperatorMapState,
  countTracePoints,
  flattenPathReportToTraces,
  getDefaultTracePeriod,
  getTracePeriodForHours,
  validateTracePeriod,
} from "./dashboardTraceUtils";
import { isValidEquipmentCoordinate } from "./dashboardMapUtils";
import { toast, ToastContainer } from "react-toastify";

function dashboardMapHeightKey(farmId) {
  return `dashboard-map-height-${farmId}`;
}

function dashboardCleanKey(farmId) {
  return `dashboard-map-clean-${farmId}`;
}

function defaultDashboardMapHeight() {
  return Math.max(640, window.innerHeight - 180);
}

function readDashboardMapHeight(farmId) {
  try {
    const raw = Number(window.localStorage.getItem(dashboardMapHeightKey(farmId)));
    if (Number.isFinite(raw) && raw >= 360) {
      return Math.min(raw, window.innerHeight - 40);
    }
  } catch (error) {
    // ignore
  }
  return defaultDashboardMapHeight();
}

function readDashboardClean(farmId) {
  try {
    return window.localStorage.getItem(dashboardCleanKey(farmId)) === "1";
  } catch (error) {
    return false;
  }
}

class Home extends Component {
  farmId = this.props.match.params.farm_id;

  FARM_URL = `${myConfig.API_URL}/farm/${this.farmId}/`;
  LANDPLOT_URL = `${myConfig.API_URL}/landplot/?farm_id=${this.farmId}`;
  MARKERS_URL = `${myConfig.API_URL}/equipment/equipments_info/?farm_id=${this.farmId}`;

  constructor(props) {
    super(props);
    const defaultTracePeriod = getDefaultTracePeriod();

    this.state = {
      loading: true,
      map: {},
      online_machines: "",
      weather_data: [],
      errors: [],
      farm: [],
      landplot: [],
      equipment: {},
      operators: {},
      marker_center: [],
      mapZoom: 0,
      modal: false,
      modalOperation: false,
      modalHoursIdle: false,
      kpi_data: [],
      periods: [],
      kpiOperations: [],
      kpiMachines: [],
      kpiReports: [],
      kpiIdle: [],
      period_id: 0,
      operations: [],
      tracePanelOpen: false,
      traceMode: "historical",
      tracePresetHours: 1,
      tracePeriodStart: defaultTracePeriod.start,
      tracePeriodEnd: defaultTracePeriod.end,
      traceLoading: false,
      traceError: "",
      historicalTracesLoaded: false,
      cleanMode: readDashboardClean(this.farmId),
      mapHeight: readDashboardMapHeight(this.farmId),
      weatherCenter: null,
      windDeg: null,
    };
    this.handleMapLoaded = this.handleMapLoaded.bind(this);
    this.saveMapViewport = null;
  }

  handleViewportActionsReady = (actions) => {
    this.saveMapViewport = actions && actions.save ? actions.save : null;
  };

  handleSaveMapViewportClick = () => {
    if (this.saveMapViewport) {
      this.saveMapViewport();
    }
  };

  applyCleanBodyClass(cleanMode) {
    document.body.classList.toggle("dashboard-map-clean-mode", Boolean(cleanMode));
  }

  componentDidMount() {
    this.applyCleanBodyClass(this.state.cleanMode);
  }

  componentWillUnmount() {
    this._unmounted = true;
    if (this.markersPollTimer) {
      clearTimeout(this.markersPollTimer);
    }
    document.body.classList.remove("dashboard-map-clean-mode");
  }

  persistMapHeight = (height) => {
    const value = height != null ? height : this.state.mapHeight;
    try {
      window.localStorage.setItem(
        dashboardMapHeightKey(this.farmId),
        String(value)
      );
    } catch (error) {
      // ignore
    }
  };

  toggleCleanMode = () => {
    this.setState((prevState) => {
      const cleanMode = !prevState.cleanMode;
      try {
        window.localStorage.setItem(
          dashboardCleanKey(this.farmId),
          cleanMode ? "1" : "0"
        );
      } catch (error) {
        // ignore
      }
      this.applyCleanBodyClass(cleanMode);
      return { cleanMode };
    });
  };

  handleMapHeightResize = (event) => {
    event.preventDefault();
    const startY = event.clientY;
    const startHeight = this.state.mapHeight;
    let latest = startHeight;
    const onMove = (moveEvent) => {
      latest = Math.max(
        360,
        Math.min(window.innerHeight - 40, startHeight + (moveEvent.clientY - startY))
      );
      this.setState({ mapHeight: latest });
    };
    const onUp = () => {
      window.removeEventListener("mousemove", onMove);
      window.removeEventListener("mouseup", onUp);
      this.persistMapHeight(latest);
    };
    window.addEventListener("mousemove", onMove);
    window.addEventListener("mouseup", onUp);
  };

  handleModal = () => {
    const { modal } = this.state;

    this.setState({ modal: !modal });
  };

  handleModalOperation = () => {
    this.setState((prev) => ({ modalOperation: !prev.modalOperation }));
  };

  handleReportsClick = () => {
    toast.info(
      this.props.t(
        "Os relatórios desta tela ainda não têm dados. Abrindo as operações."
      ),
      { position: "bottom-right" }
    );
    if (!this.state.modalOperation) {
      this.handleModalOperation();
    }
  };

  handleModalHoursIdle = () => {
    // console.log("handleModalHoursIdle");
    const { modalHoursIdle } = this.state;

    this.setState({ modalHoursIdle: !modalHoursIdle });
  };

  handleMapLoaded(e, colors) {
    if (this.state.mapLoaded === false) {
      this.setState({
        line_color: colors,
        mapLoaded: true,
      });
    }
  }

  same_position(last_posi, new_posi) {
    if (last_posi.lat !== new_posi.lat) {
      if (last_posi.lng !== new_posi.lng) {
        return false;
      }
    }

    return true;
  }

  onZoomChanged = (e) => {
    this.setState({
      marker_center: [],
    });
  };

  handleMapCenterChanged = (center) => {
    if (!center || !Number.isFinite(center.lat) || !Number.isFinite(center.lng)) {
      return;
    }
    const prev = this.state.weatherCenter;
    if (
      prev &&
      Math.abs(prev.lat - center.lat) < 0.0008 &&
      Math.abs(prev.lng - center.lng) < 0.0008
    ) {
      return;
    }
    this.setState({ weatherCenter: center });
  };

  handleWindChange = (windDeg) => {
    const next = Number(windDeg);
    if (!Number.isFinite(next)) return;
    if (this.state.windDeg === next) return;
    this.setState({ windDeg: next });
  };

  load_markers_data() {
    axios({
      baseURL: this.MARKERS_URL,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    })
      // axios.get(this.MARKERS_URL)
      .then((res) => {
        let response = res.data;
        if (res.status === 200) {
          let equipment_data = {};

          for (let i = 0; i < response.length; i++) {
            const previousPoints =
              this.state.equipment[response[i].id] &&
              this.state.equipment[response[i].id].last_posi_point
                ? this.state.equipment[response[i].id].last_posi_point
                : [];

            equipment_data[response[i].id] = {
              id: response[i].id,
              ident: response[i].ident,
              farm: response[i].farm,
              farm_name: response[i].farm_name,
              category: response[i].category,
              marca: response[i].marca,
              category_name: response[i].category_name,
              sub_category: response[i].sub_category,
              subcategory_name: response[i].subcategory_name,
              capacity: response[i].capacity,
              manufacture_year: response[i].manufacture_year,
              classification: response[i].classification,
              manufacturer: response[i].manufacturer,
              device_uid: response[i].device_uid,
              machine_status: response[i].machine_status,
              traccar_ico: response[i].traccar_ico,
              speed: response[i].speed,
              last_connection: response[i].last_connection,
              operation: response[i].operation,
              operator_label: response[i].operator_label,
              last_posi_point: previousPoints,
              extra_inf: response[i].extra_inf,
            };

            const lastPoint = response[i].last_posi_point;
            if (!isValidEquipmentCoordinate(lastPoint)) {
              continue;
            }

            const newPoint = {
              lat: lastPoint.lat,
              lng: lastPoint.lng,
            };

            equipment_data[response[i].id]["last_posi_point"] = appendMovedPoint(
              previousPoints,
              newPoint
            );
          }

          this.setState(
            {
              equipment: equipment_data,
            },
            () => {
              if (!this._initialTracesRequested) {
                this._initialTracesRequested = true;
                this.loadDashboardTraces();
              }
            }
          );

          this.scheduleMarkersPoll();
          this.refreshOperatorLastKnown();
        } else {
          this.setState({
            errors: this.state.errors.concat(
              getErrorComponent(res.data.detail)
            ),
          });
        }
      })
      .catch(() => {
        this.scheduleMarkersPoll();
      });
  }

  scheduleMarkersPoll() {
    if (this._unmounted) return;
    if (this.markersPollTimer) {
      clearTimeout(this.markersPollTimer);
    }
    this.markersPollTimer = setTimeout(() => {
      this.load_markers_data();
    }, 10000);
  }

  load_landplot_data() {
    axios({
      baseURL: this.LANDPLOT_URL,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    })
      .then((res) => {
        let landplot = res.data;
        if (res.status === 200) {
          this.setState({
            landplot: landplot,
          });
        } else {
          this.setState({
            errors: this.state.errors.concat(
              getErrorComponent(res.data.detail)
            ),
          });
        }
      })
      .catch((error) => {
        // console.log(error);
        alert(
          "Falha ao carregar talhões, recarregue a página ou tente novamente mais tarde"
        );
      });
  }

  async fetchKpis() {
    let { farm } = this.state;

    try {
      const KPI_URL = `${myConfig.API_URL}/dashboard/?farm_id=${this.farmId}`;

      let response = await axios({
        baseURL: KPI_URL,
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });

      const kpi = await response.data;

      if (response.status === 200) {
        this.setState({
          periods: kpi.idle_info,
          loading: false,
          kpi_data: kpi,
          map: {
            centroidLat: farm.latitude.toString().replace(",", "."),
            centroidLng: farm.longitude.toString().replace(",", "."),
          },
        });

        if (window.location.pathname.length < 6) {
          setTimeout(this.fetchKpis.bind(this), 10000);
        }
      }
    } catch (err) {
      // console.log("err");
    }
  }

  setPeriod = (period) => {
    // console.log("period ***", period);
    this.setState({
      period_id: period,
    });
  };

  handleTracePanelToggle = () => {
    this.setState((prevState) => ({
      tracePanelOpen: !prevState.tracePanelOpen,
    }));
  };

  handleTracePresetHours = (hours) => {
    const { start, end } = getTracePeriodForHours(hours);
    this.setState(
      {
        tracePeriodStart: start,
        tracePeriodEnd: end,
        tracePresetHours: hours,
        traceMode: "historical",
        traceError: "",
      },
      () => this.loadDashboardTraces()
    );
  };

  operatorAuthHeaders() {
    return {
      Authorization: `Bearer ${localStorage.getItem("client-token")}`,
    };
  }

  async fetchOperatorLastKnown() {
    try {
      const response = await axios({
        baseURL: `${myConfig.BE_URL}/api/operator/positions/?farm_id=${this.farmId}&latest=1`,
        method: "GET",
        headers: this.operatorAuthHeaders(),
      });
      const positions = response.data && response.data.positions;
      if (Array.isArray(positions)) {
        return positions;
      }
    } catch (error) {
      // fallback abaixo
    }

    try {
      const operatorsResponse = await axios({
        baseURL: `${myConfig.API_URL}/operator/?farm_id=${this.farmId}`,
        method: "GET",
        headers: this.operatorAuthHeaders(),
      });
      const list = Array.isArray(operatorsResponse.data)
        ? operatorsResponse.data
        : operatorsResponse.data.results || [];
      const lasts = await Promise.all(
        list.map(async (operator) => {
          try {
            const last = await axios({
              baseURL: `${myConfig.BE_URL}/api/operator/${operator.id}/last-position/`,
              method: "GET",
              headers: this.operatorAuthHeaders(),
            });
            return last.data && last.data.position;
          } catch (error) {
            return null;
          }
        })
      );
      return lasts.filter(Boolean);
    } catch (error) {
      return [];
    }
  }

  async fetchOperatorTrailPositions(start, end) {
    const { from, to } = buildUtcFromToParams(start, end);
    try {
      const response = await axios({
        baseURL: `${myConfig.BE_URL}/api/operator/positions/?farm_id=${this.farmId}&from=${encodeURIComponent(
          from
        )}&to=${encodeURIComponent(to)}&limit=5000`,
        method: "GET",
        headers: this.operatorAuthHeaders(),
      });
      return (response.data && response.data.positions) || [];
    } catch (error) {
      return [];
    }
  }

  refreshOperatorLastKnown = async () => {
    if (this._unmounted) return;
    const lastKnown = await this.fetchOperatorLastKnown();
    if (this._unmounted || !Array.isArray(lastKnown) || lastKnown.length === 0) {
      return;
    }

    const { tracePeriodStart, tracePeriodEnd } = this.state;
    const operators = { ...this.state.operators };
    lastKnown.forEach((position) => {
      const next = buildOperatorMapState([position], [], new Date())[
        position.operator
      ];
      if (!next) return;
      const previous = operators[position.operator];
      const trail = previous ? previous.last_posi_point : [];
      const stamp = position.timestamp ? new Date(position.timestamp) : null;
      const inPeriod =
        stamp &&
        !Number.isNaN(stamp.getTime()) &&
        stamp >= tracePeriodStart &&
        stamp <= tracePeriodEnd;

      operators[position.operator] = {
        ...(previous || {}),
        ...next,
        last_posi_point: inPeriod
          ? appendMovedPoint(trail, next.lastKnown)
          : trail,
      };
    });

    this.setState({ operators });
  };

  async loadDashboardTraces() {
    const { tracePeriodStart, tracePeriodEnd, equipment } = this.state;
    const validationError = validateTracePeriod(
      tracePeriodStart,
      tracePeriodEnd
    );

    if (validationError) {
      this.setState({ traceError: validationError });
      return;
    }

    const machineIds = Object.keys(equipment).map((id) => parseInt(id, 10));

    this.setState({
      traceLoading: true,
      traceError: "",
      traceMode: "historical",
    });

    try {
      const dt_ini = getFormatedDate(tracePeriodStart);
      const dt_end = getFormatedDate(tracePeriodEnd);
      const trailPromise =
        machineIds.length > 0
          ? axios({
              baseURL: `${myConfig.API_URL}/equipment/path_report/?farm_id=${this.farmId}&eq=${machineIds}&dt_ini=${dt_ini}&dt_end=${dt_end}&ldps=&in_ldp=true&out_ldp=true`,
              method: "GET",
              headers: this.operatorAuthHeaders(),
            })
          : Promise.resolve({ data: [] });

      const [pathResponse, lastKnown, trailPositions] = await Promise.all([
        trailPromise,
        this.fetchOperatorLastKnown(),
        this.fetchOperatorTrailPositions(tracePeriodStart, tracePeriodEnd),
      ]);

      const traces = flattenPathReportToTraces(pathResponse.data, equipment);
      const updatedEquipment = { ...equipment };
      let loadedPoints = 0;

      Object.keys(updatedEquipment).forEach((id) => {
        const historicalPoints = traces[id] || [];
        const currentPoints = updatedEquipment[id].last_posi_point || [];
        const livePoint = currentPoints.find((point) =>
          isValidEquipmentCoordinate(point)
        );

        if (historicalPoints.length > 0) {
          loadedPoints += historicalPoints.length;
          updatedEquipment[id] = {
            ...updatedEquipment[id],
            last_posi_point: appendMovedPoint(
              [...historicalPoints],
              livePoint
            ),
          };
          return;
        }

        if (livePoint) {
          updatedEquipment[id] = {
            ...updatedEquipment[id],
            last_posi_point: [livePoint],
          };
        }
      });

      const operators = buildOperatorMapState(
        lastKnown,
        trailPositions,
        new Date()
      );
      loadedPoints += countTracePoints(operators);

      if (this._unmounted) return;

      this.setState({
        equipment: updatedEquipment,
        operators,
        traceLoading: false,
        historicalTracesLoaded: true,
        traceError:
          loadedPoints === 0
            ? this.props.t
              ? this.props.t(
                  "Nenhum rastro GPS no período selecionado. Máquinas e operadores permanecem no último ponto conhecido."
                )
              : "Nenhum rastro GPS no período selecionado. Máquinas e operadores permanecem no último ponto conhecido."
            : "",
      });
    } catch (error) {
      const apiMessage =
        error &&
        error.response &&
        error.response.data &&
        (error.response.data.detail || error.response.data.message);

      if (this._unmounted) return;
      this.setState({
        traceLoading: false,
        traceError:
          typeof apiMessage === "string" && apiMessage
            ? apiMessage
            : "Falha ao carregar rastros históricos. Verifique o período e tente novamente.",
      });
    }
  }

  load_kpi_data() {
    axios({
      baseURL: this.FARM_URL,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("client-token")}`,
      },
    }).then((res) => {
      let farm = res.data;

      if (res.status === 200) {
        this.setState({
          farm,
        });

        this.fetchKpis();
      } else {
        this.setState({
          errors: this.state.errors.concat(getErrorComponent(res.data.detail)),
        });
      }
    });
  }

  async loadOperations() {
    try {
      const URL = `${myConfig.API_URL}/operation/?farm_id=${this.farmId}&fineshed=0`;

      let response = await axios({
        baseURL: URL,
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("client-token")}`,
        },
      });

      let data = response.data;

      this.setState({
        operations: data,
      });
    } catch (e) {
      let error_msg =
        "Falha ao carregar operações, recarregue a página e tente novamente";

      alert(error_msg);
    }
  }

  async componentWillMount() {
    //GTM

    //KPI's
    await this.load_kpi_data();
    // landplot
    this.load_landplot_data();
    // markers
    this.load_markers_data();
    // operations
    this.loadOperations();

    document.title = "Agriconnected - Painel";
  }

  load_map() {
    let {
      mapZoom,
      marker_center,
      map,
      landplot,
      farm,
      equipment,
      operators,
      modal,
      modalOperation,
      modalHoursIdle,
      tracePanelOpen,
      tracePresetHours,
      traceLoading,
      traceError,
    } = this.state;

    const { cleanMode, mapHeight } = this.state;

    return (
      <div
        className={cleanMode ? "map-container is-clean" : "map-container"}
        style={{
          height: cleanMode ? "100vh" : mapHeight,
          minHeight: cleanMode ? "100vh" : mapHeight,
        }}
      >
        <MapContainer
          zoomChanged={this.onZoomChanged}
          mapZoom={mapZoom}
          marker_center={marker_center}
          map={map}
          equipments={equipment}
          operators={operators}
          farm={farm}
          handleLoaded={this.handleMapLoaded}
          landplot={landplot}
          farm_id={this.farmId}
          mapHeight={mapHeight}
          cleanMode={cleanMode}
          onSaveViewportExtra={this.persistMapHeight}
          onMapCenterChanged={this.handleMapCenterChanged}
          onViewportActionsReady={this.handleViewportActionsReady}
        />
        <DashboardHourlyForecastBar
          farm={farm}
          mapCenter={this.state.weatherCenter}
          onWindChange={this.handleWindChange}
        />
        <DashboardDailyForecastColumn
          farm={farm}
          mapCenter={this.state.weatherCenter}
        />
        <DashboardWindArrow windDeg={this.state.windDeg} />
        <RadioMapWidget farmId={this.farmId} />
        {cleanMode ? null : (
          <div className="dashboard-map-hud dashboard-map-hud--rastros">
            <div className="map-side-panel map-side-panel--hud">
              <DashboardTracePanel
                t={this.props.t}
                open={tracePanelOpen}
                onToggle={this.handleTracePanelToggle}
                onPresetHours={this.handleTracePresetHours}
                activePresetHours={tracePresetHours}
                traceLoading={traceLoading}
                traceError={traceError}
                machineCount={Object.keys(equipment).length}
                operatorCount={Object.keys(operators).length}
                pointCount={
                  countTracePoints(equipment) + countTracePoints(operators)
                }
              />
            </div>
          </div>
        )}
        {cleanMode ? null : (
          <div className="dashboard-map-hud dashboard-map-hud--save">
            <button
              type="button"
              className="dashboard-hud-icon-btn"
              onClick={this.handleSaveMapViewportClick}
              title={this.props.t("Salvar posição do mapa")}
            >
              <FaMapMarkedAlt style={{ marginRight: 6 }} />
              {this.props.t("Salvar posição do mapa")}
            </button>
          </div>
        )}
        <div className="dashboard-map-hud dashboard-map-hud--expand">
          <button
            type="button"
            className="dashboard-hud-icon-btn"
            onClick={this.toggleCleanMode}
            title={
              cleanMode
                ? this.props.t("Sair da tela limpa")
                : this.props.t("Tela limpa")
            }
          >
            {cleanMode ? <FaCompress /> : <FaExpand />}
          </button>
        </div>
        {cleanMode ? null : (
          <div
            className="map-container-resize"
            title={this.props.t("Arraste para ampliar o mapa")}
            onMouseDown={this.handleMapHeightResize}
          />
        )}
        <div className="modal-list-machines-web">
          {modal && (
            <div className="x_panel">
              {this.renderMachines()}

              <Link
                to={`/${this.farmId}/equipment/machine/add/`}
                className="btn btn-kpi-add"
              >
                {" "}
                <FaPlus size={20} />{" "}
              </Link>
            </div>
          )}
        </div>

        <div className="modal-list-operations-web">
          {modalOperation && (
            <>
              <div className="x_panel">
                {this.renderOperations()}

                <Link
                  to={`/${this.farmId}/operation/add/`}
                  className="btn btn-kpi-add"
                >
                  {" "}
                  <FaPlus size={20} />{" "}
                </Link>
              </div>
            </>
          )}
        </div>

        <div className="modal-list-machine-idle-web">
          {modalHoursIdle && (
            <>
              <div className="x_panel">{this.renderMachinesIdle()}</div>
            </>
          )}
        </div>
      </div>
    );
  }

  renderMachinesIdle() {
    let { periods, period_id } = this.state;

    return (
      <div className="table-machines-idle">
        <table className="table table-striped">
          <thead>
            <tr>
              <th>{this.props.t("Identificação")}</th>
              <th>{this.props.t("Tempo ocioso")}</th>
            </tr>
          </thead>
          <tbody>
            {periods[period_id].equipments.map((item) => (
              <tr key={item.name}>
                <td scope="row">{item.equipment_name}</td>
                <td>{item.hours}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }

  renderMachines() {
    const { equipment } = this.state;

    return (
      <>
        <ul className="list-group list-machines-with-link">
          {Object.keys(equipment).map((item) => {
            return (
              <li
                className="list-group-item d-flex justify-content-between align-items-center"
                key={equipment[item].id}
              >
                <Link
                  to={`/${this.farmId}/equipment/machine/${equipment[item].id}/report`}
                  className="machine-link-detail"
                >
                  <strong>{equipment[item].ident}</strong>
                </Link>
              </li>
            );
          })}
        </ul>
      </>
    );
  }

  renderOperations() {
    const { operations } = this.state;

    return (
      <>
        <ul className="list-group list-operations-with-link">
          {operations.map((item) => {
            return (
              <li
                className="list-group-item d-flex justify-content-between align-items-center"
                key={item.id}
              >
                <Link
                  to={`/${this.farmId}/operation/${item.id}/progress/`}
                  className="machine-link-detail"
                >
                  <strong>{item.ident}</strong>
                </Link>
              </li>
            );
          })}
        </ul>
      </>
    );
  }

  get_content() {
    let { modal, modalOperation, modalHoursIdle } = this.state;

    return (
      <>
        <div className="modal-list-machine-idle-mobile">
          {modalHoursIdle && (
            <>
              <div className="x_panel-idle-mobile">
                {this.renderMachinesIdle()}
              </div>
            </>
          )}
        </div>
        <div className="modal-list-operations-mobile">
          {modalOperation && (
            <div className="x_panel-operations-mobile">
              {this.renderOperations()}

              <Link
                to={`/${this.farmId}/equipment/operation/add/`}
                className="btn btn-kpi-add"
              >
                {" "}
                <FaPlus size={20} />{" "}
              </Link>
            </div>
          )}
        </div>

        <div className="modal-list-machines-mobile">
          {modal && (
            <div className="x_panel-mobile">
              {this.renderMachines()}

              <Link
                to={`/${this.farmId}/equipment/machine/add/`}
                className="btn btn-kpi-add"
              >
                {" "}
                <FaPlus size={20} />{" "}
              </Link>
            </div>
          )}
        </div>

        {this.load_map()}
      </>
    );
  }

  showPopup() {
    let client = JSON.parse(localStorage.client);

    if (client.accepted_terms !== true) {
      return <PoupUp user_id={client.id} farm_id={this.farmId} />;
    }
  }

  displayKpis() {
    let { kpi_data, periods, period_id, loading } = this.state;

    return (
      <div className="row tile_count ind-container">
        {loading ? (
          <>
            <div className="col-xs-12 col-md-3 col-lg-3 col-sm-6 ">
              <div className="x_panel no-margin-top animate"></div>
            </div>
            <div className="col-xs-12 col-md-3 col-lg-3 col-sm-6 ">
              <div className="x_panel no-margin-top animate"></div>
            </div>{" "}
            <div className="col-xs-12 col-md-3 col-lg-3 col-sm-6 ">
              <div className="x_panel no-margin-top animate"></div>
            </div>{" "}
            <div className="col-xs-12 col-md-3 col-lg-3 col-sm-6 ">
              <div className="x_panel no-margin-top animate"></div>
            </div>
          </>
        ) : (
          <KpisGadgets
            periods={periods}
            period_id={period_id}
            kpi={kpi_data}
            farm_id={this.farmId}
            handleModal={this.handleModal}
            setPeriod={this.setPeriod}
            handleModalOperation={this.handleModalOperation}
            handleReportsClick={this.handleReportsClick}
            handleModalHoursIdle={this.handleModalHoursIdle}
          />
        )}
      </div>
    );
  }

  render() {
    let { loading } = this.state;

    let PoupUp;
    let content;

    if (loading === false) {
      content = this.get_content();
      PoupUp = this.showPopup();
    } else {
      content = <ShimmerLoadingMap />;
    }

    return (
      <div className="dashboard">
        {this.displayKpis()}

        {content}
        {PoupUp}
        <ToastContainer />
        <FloatingWhatsApp
          accountName="Agriconnected"
          phone="5511999061384"
          account="5511999061384"
          label="Fale conosco"
          backgroundColor="#25d366"
          position="right"
          initialMessageByServer="Olá, gostaria de falar com nosso suporte?"
          initialMessageByClient="Olá, poderia me ajudar?"
          statusMessage="Disponível"
          startChatText="Falar com suporte"
          tooltipText="Fale conosco"
          allowEsc={true}
        />
      </div>
    );
  }
}

function ShimmerLoadingMap() {
  return (
    <>
      <div className="shimmer-map-container animate"></div>
    </>
  );
}

export default withTranslation()(Home);
